import { NextResponse } from "next/server";

type Body = {
  name?: string;
  metadata?: Record<string, string>;
};

type ForwardOptions = {
  request: Request;
  apiKey?: string | null;
  datafastVisitorId?: string | null;
};

export async function forwardDatafastGoal({
  request,
  apiKey,
  datafastVisitorId,
}: ForwardOptions) {
  try {
    const { name, metadata }: Body = await request.json().catch(() => ({}));

    if (!name) {
      return NextResponse.json({ error: "name is required" }, { status: 400 });
    }

    if (!apiKey) {
      return NextResponse.json(
        { error: "DataFast server tracking not configured" },
        { status: 501 },
      );
    }

    const upstreamResponse = await fetch("https://datafa.st/api/v1/goals", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${apiKey}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        datafast_visitor_id: datafastVisitorId,
        name,
        metadata,
      }),
      cache: "no-store",
    });

    const json = await upstreamResponse.json().catch(() => ({}));

    if (!upstreamResponse.ok) {
      return NextResponse.json(
        { error: "Upstream error", detail: json },
        { status: upstreamResponse.status },
      );
    }

    return NextResponse.json(json, { status: 200 });
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.error("Datafast goal forwarding failed", error);
    }

    return NextResponse.json({ error: "Failed to track goal" }, { status: 500 });
  }
}
